module.exports = __webpack_public_path__ + "media/Audio17_u.06f824da.wav";